import { Observable } from 'rxjs';

import { DeviceNtpNetworkProtocolMode, Response } from '@shure/shared/angular/data-access/system-api/models';

import { NtpDateTimeSettingsDevice } from './models';

/**
 * `NtpDateTimeSettingsApiService` is an abstraction for **all** the functionality required by the NTP date-time settings
 * page.
 */
export abstract class NtpDateTimeSettingsApiService {
	/**
	 * Get device by id.
	 */
	public abstract getDevice$(deviceId: string): Observable<NtpDateTimeSettingsDevice>;

	/**
	 * Toggle the device NTP Protocal.
	 */
	public abstract toggleNetworkTimeProtocol(deviceId: string, enable: boolean): Observable<Response<void, string>>;
	/**
	 * Update the device NTP date-time NTP configuration settings.
	 */
	public abstract updateNtpServerConfiguration(
		deviceId: string,
		mode: DeviceNtpNetworkProtocolMode,
		manualConfiguration: string[]
	): Observable<Response<void, string>>;

	/**
	 * Get the current NTP time
	 */
	public abstract getCurrentTime(deviceId: string): Observable<string | undefined>;
}
